import { API } from "@/lib/api";

export async function downloadApiFile(path, filename) {
  const res = await fetch(`${API}${path}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("fx_token")}`,
      "X-Company-Id": localStorage.getItem("fx_company") || "",
    },
    credentials: "include",
  });
  if (!res.ok) {
    let msg = `Download failed (${res.status})`;
    try {
      const j = await res.json();
      if (j?.detail) msg = j.detail;
    } catch (e) {
      console.warn("download error body was not JSON", e);
    }
    throw new Error(msg);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

export async function openInvoicePdf(voucherId, number, mode = "download") {
  const res = await fetch(`${API}/invoices/${voucherId}/pdf`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("fx_token")}`,
      "X-Company-Id": localStorage.getItem("fx_company") || "",
    },
    credentials: "include",
  });
  if (!res.ok) throw new Error(`PDF failed (${res.status})`);  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  if (mode === "print") {
    const w = window.open(url, "_blank");
    if (w) w.onload = () => w.print();
  } else {
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(number || "invoice").replace(/\//g, "-")}.pdf`;
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}
